const cards = [
  {
    title: '刃牙角色实力排行榜TOP20',
    desc: '从范马勇次郎到花山薰，刃牙漫画全系列角色战斗力全面解析与排名。',
    tag: '深度分析',
    img: 'https://readdy.ai/api/search-image?query=Manga%20character%20power%20ranking%20visual%20style%2C%20strong%20warrior%20silhouettes%20in%20dramatic%20lighting%2C%20brushstroke%20ink%20effects%2C%20warm%20crimson%20and%20amber%20color%20scheme%2C%20atmospheric%20japanese%20manga%20aesthetic%2C%20no%20text&width=600&height=400&seq=cards-baki-1&orientation=landscape',
  },
  {
    title: '地下斗技场十大经典战役',
    desc: '刃牙第一部中令人热血沸腾的十场对决，每一战都是格斗漫画教科书。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Underground%20arena%20battle%20scene%20manga%20art%20style%2C%20dramatic%20fight%20composition%20with%20intense%20lighting%2C%20brushstroke%20textures%2C%20warm%20golden%20and%20red%20accents%2C%20atmospheric%20and%20epic%2C%20no%20text&width=600&height=400&seq=cards-baki-2&orientation=landscape',
  },
  {
    title: '死刑犯篇：五大格斗流派解析',
    desc: '柳龙光的毒手、铎尔的柔术、西科尔斯基的拳击——五种极致格斗风格对比。',
    tag: '格斗百科',
    img: 'https://readdy.ai/api/search-image?query=Martial%20arts%20style%20comparison%20manga%20art%2C%20different%20fighting%20stances%20in%20silhouette%2C%20dramatic%20ink%20wash%20style%2C%20warm%20crimson%20undertones%2C%20japanese%20brushstroke%20aesthetic%2C%20no%20text&width=600&height=400&seq=cards-baki-3&orientation=landscape',
  },
  {
    title: '宫本武藏在刃牙世界的剑术哲学',
    desc: '传奇剑豪如何在现代诠释古流剑术，刃牙道中的武学思想深度剖析。',
    tag: '文化解读',
    img: 'https://readdy.ai/api/search-image?query=Samurai%20sword%20philosophy%20manga%20art%20style%2C%20traditional%20katana%20with%20ink%20brush%20effects%2C%20dramatic%20amber%20lighting%2C%20japanese%20sumi-e%20aesthetic%2C%20atmospheric%20composition%2C%20no%20text&width=600&height=400&seq=cards-baki-4&orientation=landscape',
  },
  {
    title: '从第一部到相扑道：刃牙画风演变',
    desc: '板垣惠介老师三十年来画风变迁，从早期粗犷到如今精密的艺术进化之路。',
    tag: '艺术家谈',
    img: 'https://readdy.ai/api/search-image?query=Manga%20art%20style%20evolution%20visual%2C%20brushstroke%20ink%20techniques%20from%20rough%20to%20refined%2C%20warm%20crimson%20and%20amber%20color%20palette%2C%20japanese%20manga%20artistic%20aesthetic%2C%20no%20text&width=600&height=400&seq=cards-baki-5&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          推荐阅读
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画深度内容精选，从角色分析到格斗百科，读懂刃牙的每一面
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cards.map((item, i) => (
            <div
              key={i}
              className={`group cursor-pointer bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all hover:border-primary-200/60 ${
                i === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'h-56' : 'h-36'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}